import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/alarm.svg';
const Alarm = () => React.createElement(IconSvg, null);
export default Alarm;
